import { useState } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import { ViewCollectAndCancel } from './viewCollectAndCancle';

export const CollectAndCancel = () => {
    const [componentSteps] = useState([
        {
            title: 'Get User',
            content:  <GetInfo apiLink='requests/getRequest' param request />,
            id: 0,
        }, {
            title: 'Collect And Cancel',
            content: <ViewCollectAndCancel/>,
            id: 1
        },
    ])

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    )
}

